﻿import React, { useContext, useState, useEffect, lazy } from 'react';
import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';
import Context, { context_type } from '@Util/Context';

import Customer_Day_Chart from '@Elements/Charts/Profile/Customer_Day_Chart';
const Customer_Week_Chart = lazy(() => import('@Elements/Charts/Profile/Customer_Week_Chart'));
const Customer_Month_Chart = lazy(() => import('@Elements/Charts/Profile/Customer_Month_Chart'));
import Customers_Total_Time_Table from '@Elements/Table/Profile/Customers_Total_Time_Table';
import Expected_Working_Hours_Chart from '@Elements/Charts/Profile/Expected_Working_Hours_Chart';
import Profile_Presentation from '@Elements/Profile_Presentation';
import Profile_Filter from '@Elements/Profile_Filter';
import Inter_Client_Time_Chart from '@Elements/Charts/Profile/Inter_Client_Time';

import { Module_Time_View_Toggler } from '@Util/Types';

export default function Profilepage(): JSX.Element {
    const [t] = useTranslation();
    const {
        todays_time_log,
        weeks_time_log,
        months_time_log,
        logged_in_user,
        current_project,
        fetch_this_weeks_timelog,
        fetch_this_months_timelog
    }: context_type = useContext(Context);

    const [data_view, set_data_view] = useState<Module_Time_View_Toggler>("day");

    useEffect(() => {
        // If weeks_time_log is empty, fetch this weeks timelog
        if (weeks_time_log.length === 0) {
            fetch_this_weeks_timelog();
        }

        // If months_time_log is empty, fetch this months timelog
        if (months_time_log.length === 0) {
            fetch_this_months_timelog();
        }
    }, [weeks_time_log, months_time_log]);

    const current_time_log = {
        day: todays_time_log,
        week: weeks_time_log,
        month: months_time_log
    };

    const viewComponents = {
        day: <Customer_Day_Chart todays_time_log={todays_time_log} />,
        week: <Customer_Week_Chart weeks_time_log={weeks_time_log} />,
        month: <Customer_Month_Chart month_time_log={months_time_log} />
    };

    return (
        <>
            <Helmet>
                <title>{`${logged_in_user?.firstName} ${logged_in_user?.lastName} - InTime`}</title>
            </Helmet>
            <div className="Page_Content_Grid">
                <section className="Page_Content_Grid_Section">
                    {viewComponents[data_view] || null}
                    <Customers_Total_Time_Table 
                        logs={current_time_log[data_view]} 
                    />
                </section>
                <section className="Page_Content_Grid_Section">
                    <Profile_Presentation
                        logged_in_user={logged_in_user}
                        current_project={current_project}
                        todays_time_log={todays_time_log}
                        weeks_time_log={weeks_time_log}
                    />
                    <Profile_Filter
                        data_view={data_view}
                        set_data_view={set_data_view}
                    />
                    <Expected_Working_Hours_Chart 
                        key={data_view}
                        data_view={data_view}
                        todays_time_log={todays_time_log}
                        weeks_time_log={weeks_time_log}
                        months_time_log={months_time_log}
                    />
                    <Inter_Client_Time_Chart
                        data_view={data_view}
                        todays_time_log={todays_time_log}
                        weeks_time_log={weeks_time_log}
                        months_time_log={months_time_log}
                    />
                </section>
            </div>
        </>
    )
}